export default __webpack_public_path__ + "static/media/pointer2.f6a4944e.png";